import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

export class LocationRequestTyroRefreshTokenAction {
    constructor(public deviceCode: string) {
    }
}

export class LocationRequestTyroRefreshTokenActionResult {
    constructor(public refreshToken: string) {
    }
}

@Injectable()
export class LocationRequestTyroRefreshTokenService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "location-request-tyro-refresh-token");
    }
}
